import { Card, Typography } from "antd";
import EditCompanyForm from "components/EditCompanyForm/EditCompanyForm";
import { Company } from "interfaces/companies";
import React from "react";
import { useHistory } from "react-router-dom";
/* import InfoAboutCompany from "containers/Company/InfoAboutCompany/InfoAboutCompany"; TODO */

const { Title } = Typography;

interface Props {
  company: Company;
}

const EditCompanyProfile: React.FC<Props> = ({ company }) => {
  const history = useHistory();

  const handleSave = () => {
    history.push(`/company/company-profile/`);
    // TODO force a rerender such that logo updates, and new data shown in edit profile form
  };

  return (
    <>
      <Title level={2}>Rediger bedriftsinformasjon</Title>
      <Card style={{ width: "100%" }}>
        <EditCompanyForm company={company} onSave={handleSave} />
      </Card>
    </>
  );
};

export default EditCompanyProfile;
